export default {
    "html" : require("./html").default,
    "js": require("./js").default,
    "minJs": require("./minJs").default,
    "css": require('./css').default,
    "cssTablet": require('./cssTablet').default,
    "cssMobile": require('./cssMobile').default,
    "scss": require('./scss').default,
    "scssTablet": require('./scssTablet').default,
    "scssMobile": require('./scssMobile').default,
    "pages": 'ProductDetails'
}